import type { FC } from "react";
import type { InsuredPersonDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { DetailCard } from "web_myplann/Portfolio/Components/Redesign/Detail/DetailCard";
import { DetailRow } from "web_myplann/Portfolio/Components/Redesign/Detail/DetailRow";
import { DetailRowCollapsible } from "web_myplann/Portfolio/Components/Redesign/Detail/DetailRowCollapsible";
import { insuredPersonsWithRisks } from "web_myplann/Portfolio/Helpers/insuredPersonsWithRisks";
import { moneyFormatter } from "web_myplann/Shared/Utils/moneyFormatters";
import {
	joinTruthy,
	nameFormatter,
} from "web_myplann/Shared/Utils/textFormatters";

const PageResources = Resources.PortfolioDetail;

type Props = {
	insuredPersons: InsuredPersonDTO[];
	currencySign: string;
};

export const InsuredPersonsList: FC<Props> = ({
	insuredPersons,
	currencySign,
}) => {
	const { t } = useResource();

	const persons = insuredPersonsWithRisks(insuredPersons);

	if (persons.length === 0) {
		return null;
	}

	return (
		<DetailCard label={t(PageResources.LifeInsurance.EnsuredPeople.title)}>
			{persons.map(({ person, risks }) => (
				<DetailRowCollapsible
					label={nameFormatter(
						joinTruthy([person.firstname, person.lastname], " "),
						null,
						person.identificationNumber,
					)}
					key={[
						person.firstname,
						person.lastname,
						person.identificationNumber,
					].join("|")}
				>
					{risks.map(({ risk, value }) => (
						<DetailRow
							key={risk.risk}
							label={t(PageResources.LifeInsurance.Risk[risk.risk])}
							value={moneyFormatter(value, currencySign)}
							valueTooltip={`${t(PageResources.SharedLabels.untilAge, {
								count: risk.toAge ?? 0,
							})} · ${t(
								PageResources.LifeInsurance.EnsuredPeople.Variant[risk.variant],
							).toLowerCase()}`}
						/>
					))}
				</DetailRowCollapsible>
			))}
		</DetailCard>
	);
};
